import ReservationRoute from './reservation.jsx'

export default ReservationRoute;